// frontend/src/hooks/useStopArrival.js
import { useRegion } from '../contexts/RegionContext';
import { usePolledResource } from './usePolledResource';

export function useStopArrival(stop, routeId) {
  const { adapter } = useRegion();
  const date = adapter.getTodayDate();
  const active = Boolean(stop && routeId);

  const { data, loading, error } = usePolledResource(
    () => adapter.fetchStopArrivalDetail(routeId, stop, date),
    [stop, routeId, date, adapter],
    { enabled: active, initialData: null }
  );

  return {
    data: active ? data : null,
    loading: active ? loading : false,
    error: active ? error : null,
  };
}